/**
 * Logger utilizado apenas em ambiente de desenvolvimento.
 * Evita exibir mensagens de depuração em produção.
 */
const logger = {
  log: (...args) => process.env.NODE_ENV === 'development' && console.log(...args),
  warn: (...args) => process.env.NODE_ENV === 'development' && console.warn(...args),
  error: (...args) => process.env.NODE_ENV === 'development' && console.error(...args),
};

export default logger;